(() => {
  if (window.pintuCarouselTitlesLoaded) return;
  window.pintuCarouselTitlesLoaded = true;
  const selector = '.collections-slider .collection-card__link';
  let frame;
  function fit() {
    document.querySelectorAll(selector).forEach(title => {
      const parent = title.parentElement;
      const width = parent.clientWidth;
      if (!width) return;
      title.style.removeProperty('font-size');
      const base = parseFloat(getComputedStyle(title).fontSize);
      let size = base;
      while (title.scrollWidth > title.clientWidth + 1 && size > 1) {
        size -= 0.25;
        title.style.fontSize = size + 'px';
      }
    });
  }
  function schedule() {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(fit);
  }
  const observer = new ResizeObserver(schedule);
  function observe() {
    document.querySelectorAll(selector).forEach(title => observer.observe(title.parentElement));
    schedule();
  }
  observe();
  document.fonts.ready.then(schedule);
  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('shopify:section:load', observe);
})();